"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var roleChecks_exports = {};
__export(roleChecks_exports, {
  grant: () => grant
});
module.exports = __toCommonJS(roleChecks_exports);
var import_check = require("../check/index.js");
function grant(roles, qualificationRoles) {
  const rolesLabel = roles != null && roles.length > 0 ? ` roles: ${roles.join(", ")}` : "";
  const qualificationRolesLabel = qualificationRoles != null && qualificationRoles.length > 0 ? `${rolesLabel.length > 0 ? " and " : " "}qualification roles: ${qualificationRoles.join(", ")}` : "";
  return import_check.check.named(
    `Can grant ${rolesLabel}${qualificationRolesLabel}`,
    import_check.check.canGrantRoles(roles ?? [], qualificationRoles ?? [], import_check.check.never)
  );
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  grant
});
//# sourceMappingURL=roleChecks.js.map
